import { createTheme } from "@mui/material"
import { darkGrey, primaryColor, secondaryColor } from "./GlobalStyle"


export const MuiLightTheme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: primaryColor
        },
        secondary: {
            main: secondaryColor
        },
        clear: {
            main: darkGrey
        },
        text: {
            primary: darkGrey
        }
    },
    components: {
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    border: "none"
                }
            }
        }
    }
})